// Storage Mock
export const mockLocalStorage = () => {
  let storage: Record<string, string> = {};

  return {
    setItem: function (key: string, value: string) {
      storage[key] = value || "";
    },
    getItem: function (key: string) {
      return key in storage ? storage[key] : null;
    },
    removeItem: function (key: string) {
      delete storage[key];
    },
    get length() {
      return Object.keys(storage).length;
    },
    key: function (i: number) {
      const keys = Object.keys(storage);
      return keys[i] || null;
    },
    clear: function () {
      storage = {};
    },
  };
};

if (!localStorage) {
  // TODO 更好的方式是修改调用代码，不是改 window 对象
  Object.defineProperty(window, "localStorage", {
    value: mockLocalStorage(),
  });
}
